var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.3338C5.20515 15.162 6.07716 16.8513 7.4502 18.0804C8.82325 19.3095 10.6015 19.9927 12.4469 19.9999C14.2922 20.0072 16.0759 19.3381 17.4586 18.1199C18.8414 16.9017 19.7268 15.2194 19.9465 13.3928C20.1662 11.5663 19.7048 9.72292 18.65 8.21338C17.5953 6.70384 16.0209 5.63339 14.2261 5.2056C12.4313 4.77782 10.5415 5.02255 8.91589 5.89325C7.29032 6.76395 6.04245 8.19988 5.4096 9.92795",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.83472V10.0014H9.17962M11.6874 12.5005C11.6874 12.7216 11.7755 12.9335 11.9322 13.0898C12.089 13.2461 12.3016 13.3339 12.5233 13.3339C12.745 13.3339 12.9576 13.2461 13.1144 13.0898C13.2712 12.9335 13.3592 12.7216 13.3592 12.5005C13.3592 12.2795 13.2712 12.0676 13.1144 11.9113C12.9576 11.755 12.745 11.6672 12.5233 11.6672C12.3016 11.6672 12.089 11.755 11.9322 11.9113C11.7755 12.0676 11.6874 12.2795 11.6874 12.5005Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup12);
export default __webpack_public_path__ + "static/media/Group 1 (2).0c0ba20d4eec966cfec713ae3e27b0b0.svg";
export { ForwardRef as ReactComponent };